// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","StrollerBoxWidget":"bfb_a bhy_tr","StrollerBoxWidget__imageCounselling":"bfb_b bhy_kg"};